module.exports = __webpack_public_path__ + "img/ne.6b648997.svg";